<template>
    <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
        <template slot="filters">
            <el-form-item label="关键词" prop="userMobile">
                <el-input v-model="query.userMobile" placeholder="请输入激活用户ID/手机号码" clearable
                    @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item label="设备类型" prop="deviceType">
                <DeviceType v-model="deviceType" />
            </el-form-item>
            <el-form-item label="激活日期" prop="date">
                <el-date-picker v-model="query.date" value-format="yyyy-MM-dd" type="daterange" range-separator="~"
                    start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </template>
        <template slot="columns">
            <el-table-column type="index" label="序号" width="100" align="center" />
            <el-table-column label="设备类型" align="center" prop="deviceType"></el-table-column>
            <el-table-column label="激活时间" align="center" prop="activationTime"></el-table-column>
            <el-table-column label="激活用户ID" align="center" prop="userId"></el-table-column>
            <el-table-column label="操作" align="center" width="140" v-if="permission('/device/list/detail')">
                <template slot-scope="{ row }">
                    <el-link :underline="false" type="primary" @click="handleDetail(row)">
                        查看详情
                    </el-link>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { page } from "@/api/device/list";
import listMixin from '@/mixins/list';
import DeviceType from "@/components/DeviceType.vue";
export default {
    components: { DeviceType },
    data() {
        return {
            // 查询参数
            query: {
                userMobile: "",
                deviceType: "",
                productType: "",
                date: [],
                category: "设备"
            },
            deviceType: [],
            deviceTypes: []
        };
    },
    mixins: [listMixin],
    watch: {
        deviceType(val) {
            if (val.length) {
                this.query.productType = val[0];
                this.query.deviceType = val[1];
            } else {
                this.query.productType = '';
                this.query.deviceType = '';
            }
        }
    },
    mounted() {

    },
    methods: {
        search() {
            this.loading = true;
            const params = {
                ...this.query,
                startTime: this.query.date && this.query.date[0] ? this.query.date[0] + " 00:00:00" : "",
                endTime: this.query.date && this.query.date[1] ? this.query.date[1] + " 23:59:59" : ""
            };
            delete params.date;
            page(params).then(({ code, result, message }) => {
                if (code == 200) {
                    this.tableData = result.records || [];
                    this.total = result.total || 0;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        handleDetail(row) {
            this.$router.push({ path: "/device/detail", query: { id: row.id } });
        },
    },
};
</script>